import React from "react";

import { ReactComponent as GridActive } from "../../assets/images/icons/layout-grid.svg";
import { ReactComponent as GridInactive } from "../../assets/images/icons/grid-inactive.svg";
import { ReactComponent as CalenderActive } from "../../assets/images/icons/calendar-active.svg";
import { ReactComponent as CalenderInactive } from "../../assets/images/icons/calendar-inactive.svg";

/**
 * ViewToggle - Toggle between grid and calendar views
 * Matches Figma design with sliding indicator
 */
const ViewToggle = ({ isCalendar, onToggle }) => {
  return (
    <div
      className="relative flex items-center rounded-[999px] overflow-hidden"
      onClick={() => onToggle?.(!isCalendar)}
    >
      {/* Grid Button (Left) */}
      <div
        className={`
          flex h-11 items-center justify-center px-4 cursor-pointer
          transition-all duration-300 ease-in-out
          ${isCalendar 
            ? "bg-[#021326] rounded-bl-[999px] rounded-tl-[999px]" 
            : "bg-[#051C33] rounded-bl-[999px] rounded-tl-[999px]"
          }
        `}
      >
        {isCalendar ? (
          <GridInactive className="w-5 h-5" />
        ) : (
          <GridActive className="w-5 h-5" />
        )}
      </div>

      {/* Calendar Button (Right) */}
      <div
        className={`
          flex h-11 items-center justify-center px-4 cursor-pointer
          transition-all duration-300 ease-in-out
          ${isCalendar 
            ? "bg-[#051C33] rounded-br-[999px] rounded-tr-[999px]" 
            : "bg-[#021326] rounded-br-[999px] rounded-tr-[999px]"
          }
        `}
      >
        {isCalendar ? (
          <CalenderActive className="w-5 h-5" />
        ) : (
          <CalenderInactive className="w-5 h-5" />
        )}
      </div>
    </div>
  );
};

export default ViewToggle;
